import { LoginResult, LoginResultTenant } from "@/types"
import { LoginDomain, TenantDomain } from "@/types/domain"
import { TenantSupport } from "@/types/tenant"
import TenantInfo from "@/types/tenantInfo"
import { SettingValuePair } from "@/types/tenantSetting"

import api from "./api"

class ApiTenant {
	private get axios () { return api.getAxios() }

	public async getTenantSettings (): Promise<SettingValuePair[]> {
		return (await this.axios.get("/tenant/settings")).data
	}

	public async saveTenantSettings (settings: { [key: string]: any }): Promise<void> {
		await this.axios.put("/tenant/settings", settings)
	}

	public async domainInUse (domainPath: string): Promise<boolean> {
		return (await this.axios.get(`/tenant/domaininuse/${domainPath}`)).data
	}

	public async getDomain (domainPath: string): Promise<LoginDomain | null> {
		return (await this.axios.get(`/tenant/domain/${domainPath}`)).data
	}

	public async getTenantDomain (): Promise<TenantDomain | null> {
		return (await this.axios.get("/tenant/domain")).data
	}

	public async setTenantDomain (domain: TenantDomain | null): Promise<void> {
		await this.axios.put("/tenant/domain", domain)
	}

	public async uploadDomainFile (logo: File) {
		await api.uploadFile(`${process.env.VUE_APP_HTTP_API_URI}files/tenantImage/0`, logo)
	}

	public async clearDomainFile () {
		await this.axios.post("/files/tenantImageClear/0")
	}

	public async selectTenant (tenantId: string, userId: string): Promise<LoginResult> {
		return (await this.axios.post("/login/tenant", { tenantId, userId })).data
	}

	public async selectTenantsList (): Promise<LoginResultTenant[]> {
		return (await this.axios.get("/login/tenantsList")).data
	}

	public async openSupportAccess (timeSpan: { value: string | null }): Promise<void> {
		await this.axios.post("/tenant/enableSupportAccess", timeSpan)
	}

	public async tenantAccess (): Promise<TenantSupport> {
		return (await this.axios.get("/tenant/supportAccess")).data
	}

	public async tenantInfoGet (includeAll: boolean | null = null): Promise<TenantInfo[]> {
		return (await this.axios.get("/tenant/info", {
			params: {
				includeAll
			}
		})).data
	}

	public async tenantInfoSet (info: TenantInfo[]): Promise<TenantInfo[]> {
		return (await this.axios.put("/tenant/info", info)).data
	}
}

const apiTenant = new ApiTenant()
export default apiTenant
